module.exports = __webpack_public_path__ + "static/media/6.357933b5.JPG";